module.exports = __webpack_public_path__ + "img/ysfw.c00807c.png";